/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClearFreelancerSelectionRequest
 */
export interface ClearFreelancerSelectionRequest {
    /**
     * 
     * @type {string}
     * @memberof ClearFreelancerSelectionRequest
     */
    advancedSearchQueryId?: string;
}

/**
 * Check if a given object implements the ClearFreelancerSelectionRequest interface.
 */
export function instanceOfClearFreelancerSelectionRequest(value: object): value is ClearFreelancerSelectionRequest {
    return true;
}

export function ClearFreelancerSelectionRequestFromJSON(json: any): ClearFreelancerSelectionRequest {
    return ClearFreelancerSelectionRequestFromJSONTyped(json, false);
}

export function ClearFreelancerSelectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClearFreelancerSelectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'advancedSearchQueryId': json['advancedSearchQueryId'] == null ? undefined : json['advancedSearchQueryId'],
    };
}

export function ClearFreelancerSelectionRequestToJSON(value?: ClearFreelancerSelectionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'advancedSearchQueryId': value['advancedSearchQueryId'],
    };
}

